/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CareTypeSchema } from '../models/CareTypeSchema';
import type { ExpertiseListSchema } from '../models/ExpertiseListSchema';
import type { InsuranceCompanySchema } from '../models/InsuranceCompanySchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InsuranceApi {
    /**
     * Get Care Type List
     * Get insurance care type list. <br>Required permission: get_insurance_care_type_list
     * @returns CareTypeSchema OK
     * @throws ApiError
     */
    public static insuranceGetCareTypeListGet({
        isRelevantForPhysiotherapists,
    }: {
        isRelevantForPhysiotherapists?: (boolean | null),
    }): CancelablePromise<Array<CareTypeSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/insurance/care-type/',
            query: {
                'is_relevant_for_physiotherapists': isRelevantForPhysiotherapists,
            },
        });
    }
    /**
     * Get Insurance Expertise List
     * Get insurance expertise list. <br>Required permission: get_insurance_expertise_list
     * @returns ExpertiseListSchema OK
     * @throws ApiError
     */
    public static insuranceGetInsuranceExpertiseListGet({
        isRelevantForPhysiotherapists,
        search,
    }: {
        isRelevantForPhysiotherapists?: (boolean | null),
        search?: (string | null),
    }): CancelablePromise<Array<ExpertiseListSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/insurance/expertise/',
            query: {
                'is_relevant_for_physiotherapists': isRelevantForPhysiotherapists,
                'search': search,
            },
        });
    }
    /**
     * Get Insurance Company List
     * Get insurance company list. <br>Required permission: get_insurance_company_list
     * @returns InsuranceCompanySchema OK
     * @throws ApiError
     */
    public static insuranceGetInsuranceCompanyListGet(): CancelablePromise<Array<InsuranceCompanySchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/insurance/insurance-company/',
        });
    }
}
